/**
 * PATH: apps/qa/src/pages/signoffs-page/RejectionModal.tsx
 * PURPOSE: Modal for rejecting a hold point with reason
 */

import { useState } from 'react'
import { X, XCircle, Loader2 } from 'lucide-react'
import type { HoldPoint } from './types'

export function RejectionModal({ holdPoint, onClose, onReject, isSubmitting }: {
  holdPoint: HoldPoint
  onClose: () => void
  onReject: (reason: string) => void
  isSubmitting: boolean
}) {
  const [reason, setReason] = useState('')

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card rounded-xl p-6 w-full max-w-md shadow-xl border border-border animate-fadeIn">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-foreground">Reject Hold Point</h3>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-accent transition-colors text-muted-foreground"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-3 rounded-lg bg-destructive/10 mb-4"><p className="font-medium text-foreground">{holdPoint.name}</p></div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-foreground mb-1.5">Rejection Reason <span className="text-destructive">*</span></label>
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Explain why this hold point is being rejected..." rows={4} className="w-full px-3 py-2 rounded-lg border border-input bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary resize-none" />
        </div>
        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-xl border border-input text-foreground font-medium hover:bg-accent transition-colors">Cancel</button>
          <button onClick={() => onReject(reason)} disabled={!reason.trim() || isSubmitting} className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-destructive text-destructive-foreground font-medium hover:bg-destructive/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            {isSubmitting ? <><Loader2 className="w-4 h-4 animate-spin" />Rejecting...</> : <><XCircle className="w-4 h-4" />Reject</>}
          </button>
        </div>
      </div>
    </div>
  )
}
